module.exports = __webpack_public_path__ + "img/app-en.332c66cb.gif";